import ChartBar from '@anm/components/charts/ChartBar';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';

import { CHART_BAR_HEIGHT, CHART_BAR_MARGIN_RIGHT } from '..';
import { analyticsSelectors } from '../../../../../../store/modules/analytics';
import ChartInfoContent from '../ChartInfoContent';
import { RelativeBlock } from '../Wrapper';
import { createTooltips } from '../helpers';
import { ChartContentProps } from '../types';

import { getPlaysTimeLabel } from './helpers';

const Content: FC<ChartContentProps> = ({ containerRef, ...restProps }) => {
  const chartData = useSelector(state =>
    analyticsSelectors.selectPeriodDataByKey(state, 'timePlayed')
  );
  const isPending = useSelector(analyticsSelectors.selectPeriodDataIsPending);
  const isError = useSelector(analyticsSelectors.selectPeriodDataIsError);
  const isLifetimeEmpty = useSelector(
    analyticsSelectors.selectPeriodDataIsLifetimeEmpty
  );

  const drawTooltipHandler = useCallback(
    params => createTooltips(params)(getPlaysTimeLabel),
    []
  );

  if (!chartData?.length || isPending || isError) {
    return (
      <ChartInfoContent {...{ ...restProps, isPending, isLifetimeEmpty }} />
    );
  }

  return (
    <RelativeBlock>
      <ChartBar
        data={chartData}
        variant="horizontal"
        maxValueRatio={1.15}
        height={CHART_BAR_HEIGHT}
        barsHorizontalPadding={4}
        containerRef={containerRef}
        drawTooltipOrLabels={drawTooltipHandler}
        margin={{ right: CHART_BAR_MARGIN_RIGHT, bottom: 1 }}
      />
    </RelativeBlock>
  );
};

export default Content;
